import initSlider from '../sliders/initSlider';
import { thumbsSliderOptions, assetInfoSliderOptions } from '../sliders/sliders';

import initSimpleParallax from '../parallax/initSimpleParallax';
import { parallaxHorizontalOptions, parallaxVerticalOptions } from '../parallax/parallax';

import animateTable from '../tables/animateTable';
import toggleRowsWithDifference from '../tables/toggleRowsWithDifference';
import highlightRowsWithDifference from '../tables/highlightRowsWithDifference';

document.addEventListener('DOMContentLoaded', (e) => {
  initSlider('[data-asset-type-slider]', thumbsSliderOptions);
  initSlider('[data-asset-info-slider]', assetInfoSliderOptions);

  /*  */

  const parallaxHorizontalCards = document.querySelectorAll('[data-parallax-horizontal-card]');
  const parallaxVerticalCards = document.querySelectorAll('[data-parallax-vertical-card]');

  initSimpleParallax(parallaxHorizontalCards, parallaxHorizontalOptions);
  initSimpleParallax(parallaxVerticalCards, parallaxVerticalOptions);

  /*  */

  const comparisonTable = document.querySelector('[data-comparison-table]');
  const switcher = document.querySelector('[data-table-switcher]');

  highlightRowsWithDifference(comparisonTable);

  switcher.addEventListener('click', (e) => {
    toggleRowsWithDifference(comparisonTable, switcher);
    animateTable(comparisonTable);
  });
});
